import store from '@/store'
export default (to, from, next) => {
  // exit if we are allowing anonymous
  if (to.matched.some(record => record.meta.allowAnonymous)) {
    next()
    return
  }
  // exit if they are not authenticated
  if (!store.getters['auth/token']) {
    store.dispatch('auth/setPassthrough', to.path)
    next(`/login`)
    return
  }
  // exit if they are not allowed by role
  if (!store.getters['auth/isAllowed'](to.path)) {
    next('/')
    return
  }
  // allowed
  next()
}



// WEBPACK FOOTER //
// ./src/router/guard.js